import React, { useState, useRef, useContext } from 'react'

import ReactPlayer from 'react-player'

import AppContext from '../../../contexts/AppContext'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import PATH from '../../../business-const/Path/Path'

import AuthService from '../../../business-api/AuthService'

import {
    FormikPadrao,
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivFormN0,
    DivFormN1,
} from '../../../business-components/Div/Div'

import BreadcrumbPadrao from '../../../business-components/Breadcrumb/Breadcrumb'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem6,
    GridItem6sm9xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import videoFuncionalidadeList from '../../../business-rules/List/videoFuncionalidadeList'

import videoCasoNegocioList from '../../../business-rules/List/videoCasoNegocioList'

import videoList from '../../../business-rules/List/videoList'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'



const VideoForm = ( {idFuncionalidade} ) => {

    const [initialValues, setInitialValues] = useState(null)

    const { variaveisGlobais } = useContext(AppContext)
    
    const Video = useRef(null)

    useSingleton(async () => {

        Video.current = {}

        if (idFuncionalidade) {

            Video.current.idFuncionalidade = idFuncionalidade
        }

        setInitialValues(Video.current)
        
        AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)
    })

    const handleSubmit = async ( values, isSubmitting ) => {
    }

    return (
        <DivFormN0>
            {!idFuncionalidade && (
                <DivFormN1>
                    <BreadcrumbPadrao
                        routeSegments={[
                            { name: LABEL.pageVideoList, path: PATH.pageVideoList },
                        ]}
                    />
                </DivFormN1>
            )}

            <DivFormN1>
                <FormikPadrao
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        validateOnChange={false} // implementado para resolver o problema de perfomance da digitação
                        validateOnBlur={false} // implementado para resolver o problema de perfomance da digitação
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setSubmitting,
                            setFieldValue,
                        }) => (
                            <ValidatorFormPadrao
                                onSubmit={handleSubmit}
                                onError={
                                    () => null
                                }
                            >
                                <GridContainer
                                    className='justify-center'
                                >
                                    <GridItem6>
                                        <CardGridEntradaDados>
                                            <CardGridDivHeaderEntradaDados>
                                                <CardGridDivEntradaDados>
                                                    {LABEL.selecioneVideoDesejado}
                                                </CardGridDivEntradaDados>
                                            </CardGridDivHeaderEntradaDados>

                                            <CardGridDivBodyEntradaDados>
                                                <GridContainer>
                                                    <GridItem12
                                                        className='mt-4'
                                                    >
                                                        <TextFieldTextSelect
                                                            name="idFuncionalidade"
                                                            label={LABEL.funcionalidade}
                                                            value={values.idFuncionalidade || ''}
                                                            onChange={(e) => {
                                                                values.idCasoNegocio = ''
                                                                values.idVideo = ''
                                                                handleChange(e)
                                                            }}
                                                            list={videoFuncionalidadeList}
                                                        />
                                                    </GridItem12>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem12
                                                        className='mt-4'
                                                    >
                                                        <TextFieldTextSelect
                                                            name="idCasoNegocio"
                                                            label={LABEL.casoNegocio}
                                                            value={values.idCasoNegocio || ''}
                                                            onChange={(e) => {
                                                                values.idVideo = ''
                                                                handleChange(e)
                                                            }}
                                                            list={videoCasoNegocioList.filter(linhaCasoNegocio => linhaCasoNegocio.idFuncionalidade === values.idFuncionalidade)}
                                                        />
                                                    </GridItem12>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem12
                                                        className='mt-4 mb-2'
                                                    >
                                                        <TextFieldTextSelect
                                                            name="idVideo"
                                                            label={LABEL.video}
                                                            value={values.idVideo || ''}
                                                            onChange={handleChange}
                                                            list={videoList.filter(linhaVideo => linhaVideo.idCasoNegocio === values.idCasoNegocio)}
                                                        />
                                                    </GridItem12>
                                                </GridContainer>
                                            </CardGridDivBodyEntradaDados>
                                        </CardGridEntradaDados>
                                    </GridItem6>
                                </GridContainer>

                                {values.idVideo
                                    ?
                                        <GridContainer>
                                            <GridItem12
                                                align="center"
                                            >
                                                <GridItem6sm9xs12
                                                    className="mt-6 mb-6"
                                                >
                                                    <ReactPlayer
                                                        url={pesquisaList(videoList, values.idVideo).url}
                                                        controls
                                                        width="100%"
                                                    />
                                                </GridItem6sm9xs12>
                                            </GridItem12>
                                        </GridContainer>
                                    :
                                        ''
                                }
                            </ValidatorFormPadrao>
                        )}
                </FormikPadrao>
            </DivFormN1>
        </DivFormN0>
    )
}

export default VideoForm